import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useModal } from '../../context/modal-context'

const MethodNotRegisteredDialog = () => {
  const { missingMethod, hideMethodNotRegistered } = useModal()
  const navigate = useNavigate()
  const handleRedirect = () => {
    hideMethodNotRegistered()
    navigate('/manage-authentications')
  }

  return (
    <Dialog open={!!missingMethod} onClose={hideMethodNotRegistered}>
      <DialogTitle>Método no registrado</DialogTitle>
      <DialogContent>
        <Typography>
          No tenés registrado el método de autenticación requerido: <strong>{missingMethod}</strong>
          .
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2}>
          <Button onClick={hideMethodNotRegistered} variant="outlined">
            Entendido
          </Button>
          <Button onClick={handleRedirect} variant="contained" color="primary">
            Ir a gestionar métodos
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default MethodNotRegisteredDialog
